<svelte:options accessors/>
<script lang="ts">
    import MainOverlay from "../layout/MainOverlay.svelte";
    import type {IProductPreview} from "../../interfaces";
    import ProductGrid from "../products/ProductGrid.svelte";
    import {onMount} from "svelte";
    import {getCodModeloTasa, getSelectedCity} from "../../utils";
    import CatalogPage from "../products/CatalogPage.svelte";
    import {Cart, getCart} from "../../models/cart";
    import LinearProgress from "@smui/linear-progress";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    export let busquedas: Array<string> = [];
    export let recientes: Array<IProductPreview> = [];
    export let searching: boolean = false;
    export let API_URL: string;
    export let API_VERSION: string;
    export let API_KEY: string;
    export let results: Array<{
        label: string,
        route: string
    }>;
    export let rawResults = [];
    export let mapperPart;
    export let mapperAccessory;
    export let mapperService;
    export let open: boolean = false;
    export let catalog: Array<any> = [];
    export let searchTerm: string;
    let cart: Cart;
    onMount(() => {
        const tmp = localStorage.getItem('busquedas');
        if (tmp) {
            try {
                busquedas = JSON.parse(tmp);
            } catch (e) {
                busquedas = [];
            }
        } else {
            busquedas = [];
        }
        getCart().then((c) => {
            cart = c;
        })
    });

    function save() {
        localStorage.setItem('busquedas', JSON.stringify(busquedas))
    }

    export function search(term: string) {
        rawResults = [];
        results = [];
        catalog = [];
        searchTerm = term.trim();
        const items = [term.trim()];
        items.push(...term.trim().split(' ').map(s => `${s}*`));
        searching = true;
        const url = new URLSearchParams({
            'api-version': API_VERSION,
            'search': items.join('|'),
            'api-key': API_KEY,
            'queryType': 'simple',
            '$top': '50'
        });
        fetch(`${API_URL}?${url.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    const {value} = data;
                    rawResults = value ?? [];
                    let items = value ?? [];
                    const selected = ManagerVehicles.getInstance().selected;
                    if (selected) {
                        items = items.filter((item) => {
                            const {type} = item;
                            const {codModeloTASA, codModelo} = selected;
                            switch (type) {
                                case 'Accesorio':
                                    const {codigos} = item;
                                    return !!(codigos ?? []).find(cod => cod === codModelo)
                                case 'Repuesto':
                                    const {codModelosTasas} = item;
                                    return !!(codModelosTasas ?? []).find(cod => cod === codModeloTASA)
                                default:
                                    return true;
                            }
                        })
                    }
                    results = items.map(v => ({...v, meta: JSON.parse(v.meta)}));
                    const selectedCity = getSelectedCity();
                    const codModeloTasa = getCodModeloTasa();
                    catalog = (results.slice(0, 20).map((r: any) => {
                        switch (r.type) {
                            case 'Accesorio':
                                return mapperAccessory ? mapperAccessory(r.meta, selectedCity, codModeloTasa) : null;
                            case 'Repuesto':
                                return mapperPart ? mapperPart(r.meta, selectedCity, codModeloTasa) : null;
                            case 'Servicio':
                                return mapperService ? mapperService(r.meta, selectedCity, codModeloTasa) : null;
                            case 'Mantenimiento Preventivo':
                            case 'Mantenimiento Prepagado':
                                return {
                                    ...r.meta,
                                    type: ''
                                };
                            default:
                                return null;
                        }
                    })).filter(r => !!r);
                    if (results.length > 0) {
                        busquedas.push(term);
                        if (busquedas.length > 5) {
                            busquedas.splice(0, 1);
                        }
                        save();
                    }
                }).catch((e) => {
                    results = [];
                });
            } else {
                response.json().then((body) => {
                    results = [];
                }).catch(() => {
                    results = [];
                });
            }
            searching = false;
        }).catch((e) => {
            searching = false;
        });
    }

</script>
<MainOverlay closeOption="{true}" bind:open={open} on:close>
    <div class="container">
        {#if searching}
            <div class="text-c loading-bar mt-2">
                <LinearProgress class="w-100" indeterminate/>
                <small>Buscando...</small>
            </div>
        {:else}
            {#if searchTerm?.length > 2 && !searching && results?.length === 0}
                <div class="pb-1">
                    <h2 class="mb-1"></h2>
                    {#if rawResults?.length > 0}
                        <h4>Producto no disponible para este vehículo.</h4>
                    {:else}
                        <h4>No se encontraron coincidencias con la búsqueda.</h4>
                    {/if}
                </div>
            {/if}
            {#if !results || results?.length === 0}
                <div class="pb-1">
                    {#if busquedas.length > 0}
                        <div class="mb-2 max-w-600px">
                            <h2 class="mb-1">Búsquedas recientes</h2>
                            <div>
                                {#each busquedas as query}
                                    <div class="py-ii border-bottom">
                                        <p>{query}</p>
                                    </div>
                                {/each}
                            </div>
                        </div>
                    {/if}
                    {#if recientes.length > 0}
                        <div>
                            <h2 class="mb-1">Vistos recientemente</h2>
                            <ProductGrid data="{recientes}"/>
                        </div>
                    {/if}
                </div>
            {:else}
                <div class="pb-1">
                    <!--<h2 class="mb-1">Resultados de tu búsqueda</h2>-->
                    <div class="search-results max-w-500px" style="max-height: 150px; overflow-y: scroll">
                        {#each results as result}
                            <a class="block py-ii border-bottom" style="color: var(--text); font-weight:300;"
                               href="{result.route}">{result.label} <span class="badge">{result.type}</span>
                                {#each result.compatibles as c}
                                    <span class="badge">{c}</span>
                                {/each}
                            </a>
                        {/each}
                    </div>
                    {#if catalog.length > 0}
                        <div class="mt-1">
                            <CatalogPage title="Resultados"
                                         data={catalog}
                                         showViewMore={false}
                                         {cart}/>
                        </div>
                    {/if}
                </div>
            {/if}
        {/if}
    </div>
</MainOverlay>
<style>
    @media (min-width: 1024px) {
        .search-results {
            margin-left: 200px;
        }
    }

    .badge {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        border: 2px solid var(--text);
        border-radius: 10px;
        font-size: 12px;
        background-color: var(--text);
        color: #fff;
    }

    .badge + .badge {
        margin-left: .5rem;
    }
</style>